<template>
<el-dialog title="选择零件" width="80%" :visible.sync="viewData.visible" :close-on-click-modal="false" append-to-body>
    <div class="content-body tenant-settings">
        <!-- <div class="" style="background: red ;display: none"> -->
        <div class="">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
                <el-form-item label="订单编码:">
                    <el-input size="small" v-model="dataForm.orderCode" placeholder="订单编码" clearable @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item label="物料编码:">
                    <el-input size="small" v-model="dataForm.partCode" placeholder="物料编码" clearable @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item label="物料名称:">
                    <el-input size="small" v-model="dataForm.partName" placeholder="物料名称" clearable @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item class="fr">
                    <el-button size="small" @click="getDataList()" icon="el-icon-search">
                        查询
                    </el-button>
                    <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button> -->
                    <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
                </el-form-item>
            </el-form>
            <div v-loading="dataListLoading">
                <el-table :data="orderPartList" row-key="id" size="small" @selection-change="selectionChangeHandle" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }">
                    <el-table-column label="选择" type="selection" width="55">
                        <template slot-scope="scope">
                            <input type="checkbox" v-model="selectPartList" :value="scope.row" />
                        </template>
                    </el-table-column>
                    <el-table-column type="index" width="50" label="序号">
                    </el-table-column>
                    <el-table-column prop="ebeln" header-align="center" align="left" label="采购订单号" width="100">
                    </el-table-column>
                    <el-table-column prop="pstyp" header-align="center" align="center" label="项目类别">
                        <template slot-scope="scope">
                            {{ PSTYP_TYPE(scope.row.pstyp) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderType" header-align="center" width="150" align="center" label="订单类型">
                        <template slot-scope="scope">
                            {{ ORDER_TYPE(scope.row.orderType) }}
                        </template>
                    </el-table-column>
                    <el-table-column width="150" prop="partCode" header-align="center" align="left" label="物料编码">
                    </el-table-column>
                    <el-table-column width="200" prop="partName" header-align="center" align="left" label="物料名称">
                    </el-table-column>
                    <el-table-column prop="count" header-align="center" align="left" label="订单数量">
                    </el-table-column>
                    <el-table-column prop="unit" header-align="center" align="center" label="单位">
                        <template slot-scope="scope">
                            <span>{{getUnitName(scope.row.unit)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="150" prop="asnRemaining" header-align="center" align="center" label="ASN剩余交货数量">
                        <template slot-scope="scope">
                            <span>{{getAsnLfimg(scope.row.asnRemaining)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="baseMeins" header-align="center" align="center" label="基本单位">
                    </el-table-column>
                    <el-table-column prop="baseQuan" header-align="center" align="right" label="基本单位数量" width="100">
                    </el-table-column>
                    <el-table-column prop="werks" header-align="center" align="center" label="工厂">
                    </el-table-column>
                    <el-table-column prop="name2" header-align="center" align="center" label="工厂名称" width="300">
                    </el-table-column>
                    <el-table-column prop="lgort" header-align="center" align="center" label="库存地点">
                    </el-table-column>
                    <el-table-column prop="lgobe" header-align="center" align="center" label="库存地点名称" width="200">
                    </el-table-column>
                    <el-table-column prop="street" header-align="center" align="left" label="收货地址" width="300">
                    </el-table-column>
                    <el-table-column prop="elikz" header-align="center" align="center" label="交货已完">
                        <template slot-scope="scope">
                            <span>{{getElikz(scope.row.elikz)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align:right" class="mt15 mb15">
            </el-pagination>
        </div>
    </div>
    <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <!-- 询价中 -->
            <el-button size="small" plain type="primary" @click="confirm()">
                确认
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    getOrderById,
    selectPartBySupplier,
    // list
} from '@/controller/order'
import {
    createDeliveryPartList,
    addDeliveryOtsPartList
} from "@/controller/delivery"
import moment from "moment"
import {
    DIALOG_CLOSED_TYPE,
    getPstypByValue,
} from "@/utils/const";
import { getAllPurchaseTypes, formatForSelect, getPurchaseTypeShortName } from '@/utils/purchaseTypeCache'
import {
    getFactoryList,
    getUnitList,
    getStorePositionTypeList
} from '@/controller/systemData'
export default {
    props: {
        partFormData: Object,
    },
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            PSTYP_TYPE: getPstypByValue,
            dataForm: {
                id: 0,
                projectName: '',
                orderCode: '',
                partCode: '',
                partName: '',
                supportingPartner: '',
                orderStatus: '',
                orderType: '',
                orderName: '',
                recieveContacterName: '',
                recieveAddress: '',
                purchaseContacterName: '',
                purchaseContacterTel: '',
                purchaseContacterMail: '',
                recieveContacterTel: '',
                orderRequirement: '',
                remark: '',
                unQuoteReason: '',
                deliveryId: '',
                street: '',
            },
            dataList: [],
            tenantList: [],
            orderPartList: [],
            unitList: [],
            factoryList: [],
            storePositionTypeList: [],
            selectPartList: [],
            supplierCode: '',
            supplierName: '',
            groupCode: '',
            ORDER_TYPE: getPurchaseTypeShortName,
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            partAddOrUpdateVisible: false,
            deliveryAddress:'',
            createTime: '',
            lichnInfo: '线下为准',
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },

    components: {},
    activated() {
        this.getDataList()
    },
    mounted() {
        this.getUnitList()
        this.getFactoryList()
        this.getStorePositionTypeList()
    },
    methods: {
        open(deliveryAddress, deliveryId, supplierCode, supplierName, groupCode) {
            this.deliveryAddress = deliveryAddress
            this.deliveryId = deliveryId
            this.supplierCode = supplierCode
            this.supplierName = supplierName
            this.groupCode = groupCode
            this.viewData.visible = true
            this.pageSize = 10
            this.pageIndex = 1
            this.getDataList()
        },
        onClosed(params) {
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            this.onClosed({
                option,
                sender: this,
                data: "OK",
            });
            this.viewData.visible = false;
        },
        confirm() {
            this.loading = true
            // 保存appartmentList零件 调用批量添加
            if (!this.selectPartList) {
                this.$message.error("请选择物料消息")
                return
            } 
            if(this.selectPartList.length === 0) {
                this.selectPartList = []
                this.close(DIALOG_CLOSED_TYPE.CLOSE);
                return
            }
            const loading = this.$loading({
                lock: true,
                text: '正在保存',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const params = this.selectPartList.map(v => {
                return {
                    orderPartId: v.id,
                    deliveryId: this.deliveryId,
                    // orderCode: v.materialCode,
                    orderCode: v.ebeln,
                    partCode: v.partCode,
                    partName: v.partName,
                    // TODO: 订单里有的代入
                    meins: v.baseMeins,
                    remark: v.remark,
                    ebeln: v.ebeln,
                    ebelp: v.ebelp,
                    werks: v.werks,
                    unit: v.unit,
                    name2: v.name2
                }
            })
            addDeliveryOtsPartList(params).then((data) => {
                if (data && data.code === "00") {
                    this.result = "OK"
                    this.$message({
                        message: "零件添加成功",
                        type: "success",
                    });
                    this.selectPartList = []
                    this.close(DIALOG_CLOSED_TYPE.CONFIRM);
                    loading.close();
                } else {
                    this.$message.error(data.msg);
                    loading.close();
                }

            }).catch(e => {
                console.error(e)
                loading.close();
            }).finally(() => {
                this.loading = false
                loading.close();
            })
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            selectPartBySupplier({
                orderId: this.dataForm.id,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                orderCode: this.dataForm.orderCode,
                partCode: this.dataForm.partCode,
                partName: this.dataForm.partName,
                street: this.deliveryAddress,
                groupCode: this.groupCode,
                count: '0',
                elikz: 'E',
                deleteFlag: 0
            }).then((data) => {
                if (data && data.code === "00") {
                    this.orderPartList = data.body.records;
                    this.totalPage = data.body.total
                } else {
                    this.orderPartList = [];
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            });
        },
        init(id) {
            // 加载采购类型数据到 _latestList（供 getPurchaseTypeShortName 渲染使用）
            getAllPurchaseTypes();
            this.dataForm.id = id || 0;
            this.orderPartList = [];
            this.viewData.visible = true;
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id找订单对象
                    getOrderById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00" && data.body) {
                            // this.dataForm.projectName = data.body.projectName;
                            // this.dataForm.orderCode = data.body.orderCode;
                            // this.dataForm.supportingPartner = data.body.supportingPartner;
                            // this.dataForm.orderStatus = data.body.orderStatus;
                            // this.dataForm.orderType = data.body.orderType;
                            // this.dataForm.orderName = data.body.orderName;
                            // this.dataForm.recieveContacterName = data.body.recieveContacterName;
                            // this.dataForm.recieveAddress = data.body.recieveAddress;
                            // this.dataForm.purchaseContacterName = data.body.purchaseContacterName;
                            // this.dataForm.purchaseContacterTel = data.body.purchaseContacterTel;
                            // this.dataForm.purchaseContacterMail = data.body.purchaseContacterMail;
                            // this.dataForm.recieveContacterTel = data.body.recieveContacterTel;
                            // this.dataForm.orderRequirement = data.body.orderRequirement;
                            // this.dataForm.remark = data.body.remark;
                            this.dataForm = data.body;

                        }
                    });
                }
            });
            this.getOrderTblPartList();
        },
        getUnitList() {
            getUnitList({
                code: '',
                name: ''
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            })
        },
        getFactoryList() {
            getFactoryList({
                factoryCode: "",
                factoryDesc: "",
                address: "",
                post: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            });
        },
        getFactoryName(code) {
            const factory = this.factoryList.find(factory => factory.factoryCode === code)
            return factory ? factory.factoryDesc : ''
        },
        getAsnLfimg(code) {
            return code ? code : '0'
        },
        getLfimg(code) {
            return code ? code : '0'
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        getElikz(code) {
            return code ? "已完成" : '未完成'
        },
        // 库位名称
        getStorePositionTypeList() {
            getStorePositionTypeList({
                storeCode: "",
                storeAddress: "",
                storeName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.storePositionTypeList = data.body;
                }
            });
        },
        getStorePositionName(code) {
            const storePosition = this.storePositionTypeList.find(storePosition => storePosition.storeAddress === code)
            return storePosition ? storePosition.storeName : ''
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.selectPartList = val
        },
        currentChange(currentRow) {
            this.currentRow = currentRow;
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD前");
        },
    }
}
</script>
